<template>
    <div>
        <div class="gapp_post__related-posts">

            <div v-if="fetching" class="gapp_post__posts--loader">
                <app-loader />
            </div>
            
            <div v-if="!fetching && postdata.length > 0" class="gapp_post__posts">

                <h2 class="gapp_post__module-title">{{ feedSettings.heading }}</h2>

                <app-post-container 
                    v-for="post in postdata" 
                    :key="post.id" 
                    :post="post">
                </app-post-container>

            </div>

        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { axiosInstance } from '../main';
import postContainer from './PostContainer.vue';
import Loader from './Loader.vue';
import ErrorMessage from './ErrorMessage.vue';
import NoResults from './NoResults.vue';

export default {

    data: function() {
        return {
            postdata: [],
            fetching: true,
            error: false,
        } 
    },
    props: {
        feedSettings: {
            type: Object
        }
    },
    components: {
        'app-post-container': postContainer,
        'app-loader': Loader,
        'app-error': ErrorMessage,
        'app-no-results': NoResults
    },
    created() {

        async function getData(slug, source_url, post_type) {
            try {
                const config = {
                    headers: { 
                        'Content-type': 'application/json'
                    }
                }
                const response = await axios.post(source_url, {
                    query: post_type == 'article' 
                    ? `
                        query GetDocument($uri: String) {
                            articleBy(uri: $uri) {
                                title
                                link
                                id
                                date
                                featuredImage {
                                    mediaItemUrl
                                }
                            }
                        }
                    `
                    : `
                        query GET_POST($uri: String) {
                            postBy(uri: $uri) {
                                id
                                title
                                date
                                link
                                featuredImage {
                                    mediaItemUrl
                                }
                            }
                        }
                    `,
                    variables: {
                        uri: slug,
                    }
                }, config)
                if ( response.status === 200 && !response.data.errors ) {
                    if ( post_type == 'article' ) {
                        return response.data.data.articleBy
                    } else {
                        return response.data.data.postBy
                    }
                } else {
                    return { 'error': response.data.errors[0].message }
                }
            } catch (error) {
                return { 'error': 'Network error' }
            }
        }

        let data = [];
        for ( let i = 0; i < this.feedSettings.slugs.length; i++ ) {
            data = data.concat(
                            getData(
                                this.feedSettings.slugs[i], 
                                `${this.feedSettings.source_url}/graphql`, 
                                this.feedSettings.post_type
                            )
                        )
        }
        
        Promise.all(data)
            .then(results => {
                let posts = []
                results.forEach(item => {
                    if ( !item.error ) {
                        posts = posts.concat(item)
                    } else {
                        this.error = item.error // e;
                    }
                })
                
                this.postdata = posts
                this.fetching = false
            })
    }
}
</script>
